import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer');

// Views
const Accounts = () => import('@/views/banking/Accounts');
const Categories = () => import('@/views/catalog/Categories');
const Products = () => import('@/views/catalog/Products');
const Contacts = () => import('@/views/catalog/Contacts');
const Users = () => import('@/views/setting/Users');
const Inputs = () => import('@/views/buy/Inputs');
const Payments = () => import('@/views/banking/Payments');
const Drafts = () => import('@/views/banking/Drafts');
const Bills = () => import('@/views/buy/Bills');
const Cheques = () => import('@/views/banking/Cheques');
const Outputs = () => import('@/views/sell/Outputs');
const Revenues = () => import('@/views/banking/Revenues');
const UserPermissions = () => import('@/views/setting/UserPermissions');
const Invoices = () => import('@/views/sell/Invoices');
const ReturnsDelivery = () => import('@/views/sell/ReturnsDelivery');
const UnAccountingSetInvoices = () => import('@/views/sell/UnAccountingSetInvoices');
const BarCodeReader = () => import('@/views/report/BarCodeReader');
const InvoiceOverallReport = () => import('@/views/report/InvoiceOverallReport');
const BillOverallReport = () => import('@/views/report/BillOverallReport');
const Settings = () => import('@/views/setting/Settings');

const ContactTransactions =  () => import('@/views/report/ContactTransactions');
const AccountTransactions =  () => import('@/views/report/AccountTransactions');
const ProductOptionsCardindex =  () => import('@/views/report/ProductOptionsCardindex');
const InventoryEntryLog = () => import('@/views/report/InventoryEntryLog');
const InventoryDiscrepancy = () => import('@/views/report/InventoryDiscrepancy');
const LastPrints = () => import('@/views/report/LastPrints');
const ExtraReports = () => import('@/views/report/ExtraReports');
const ShopCardex = () => import('@/views/report/ShopCardex');

const Referer = () => import('@/views/report/Referer');
const DeliveryContacts = () => import('@/views/report/DeliveryContacts');


// Views - Pages
const Page404 = () => import('@/views/pages/Page404');
const Page500 = () => import('@/views/pages/Page500');
const Login = () => import('@/views/pages/Login');
const Register = () => import('@/views/pages/Register');

const Dashboard = () => import('@/views/Dashboard');

Vue.use(Router);

const router = new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'active',
    scrollBehavior: () => ({y: 0}),
    routes: configRoutes()
});
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem('token') == null) {
            next({
                path: '/pages/login',
                params: {nextUrl: to.fullPath}
            })
        } else {
            next()
        }
    } else if (to.matched.some(record => record.meta.guest)) {
        if (localStorage.getItem('token') == null) {
            next()
        } else {
            next({name: 'userboard'})
        }
    } else {
        next()
    }
});
export default router

function configRoutes() {
    return [
        {
            path: '/',
            redirect: '/dashboard',
            name: 'Home',
            component: TheContainer,
            children: [
                {
                    path: 'dashboard',
                    name: 'Dashboard',
                    component: Dashboard,
                    meta: {
                        requiresAuth: true,
                        title: 'داشبورد'
                    }
                },
                {
                    path: 'catalog',
                    redirect: '/catalog/categoryPermissions',
                    name: 'Catalog',
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                        {
                            path: 'categories',
                            name: 'Categories',
                            component: Categories,
                            meta: {
                                requiresAuth: true,
                                title: 'دسته بندی ها'
                            }
                        },
                        {
                            path: 'contacts',
                            name: 'Contacts',
                            component: Contacts,
                            meta: {
                                requiresAuth: true,
                                title: 'اشخاص'
                            }
                        },
                        {
                            path: 'products',
                            name: 'Products',
                            component: Products,
                            meta: {
                                requiresAuth: true,
                                title: 'محصولات'
                            }
                        },
                        {
                            path: 'contacttransactions/:id?',
                            name: 'contacttransactions',
                            component: ContactTransactions,
                            meta: {
                                requiresAuth: true,
                                title: 'تراکنش های یک شخص'
                            }
                        }                        
                    ],
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'banking',
                    redirect: '/banking/accounts',
                    name: 'Banking',
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                        {
                            path: 'accounts',
                            name: 'Accounts',
                            component: Accounts,
                            meta: {
                                requiresAuth: true,
                                title: 'حساب های بانکی'
                            }
                        },
                        {
                            path: 'payments/:id?',
                            name: 'Payments',
                            component: Payments,
                            meta: {
                                requiresAuth: true,
                                title: 'پرداختی ها'
                            }
                        }, {
                            path: 'cheques',
                            name: 'Cheques',
                            component: Cheques,
                            meta: {
                                requiresAuth: true,
                                title: 'چک ها'
                            }
                        }, {
                            path: 'revenues/:id?',
                            name: 'Revenues',
                            component: Revenues,
                            meta: {
                                requiresAuth: true,
                                title: 'درامدها'
                            }
                        }, {
                            path: 'drafts/:id?',
                            name: 'Drafts',
                            component: Drafts,
                            meta: {
                                requiresAuth: true,
                                title: 'حواله حساب ها'
                            }
                        }
                    ],
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'setting',
                    redirect: '/setting/users',
                    name: 'Setting',
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                        {
                            path: 'settings',
                            name: 'settings',
                            component: Settings,
                            meta: {
                                requiresAuth: true,
                                title: 'تنظیمات'
                            }
                        },                        
                        {
                            path: 'users',
                            name: 'Users',
                            component: Users,
                            meta: {
                                requiresAuth: true,
                                title: 'کاربران'
                            }
                        },
                        {
                            path: 'userpermissions',
                            name: 'UserPermissions',
                            component: UserPermissions,
                            meta: {
                                requiresAuth: true,
                                title: 'دسترسی کاربران'
                            }
                        }
                    ],
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'report',
                    redirect: '/report/brcodereader',
                    name: 'Reports',
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                        
                        {
                            path: 'inventoryentrylog/:id?',
                            name: 'InventoryEntryLog',
                            component: InventoryEntryLog,
                            meta: {
                                requiresAuth: true,
                                title: 'ورود و خروج انبار'
                            }
                        },                        
                        {
                            path: 'brcodereader/:id?',
                            name: 'BarCodeReader',
                            component: BarCodeReader,
                            meta: {
                                requiresAuth: true,
                                title: 'بارکدخوان'
                            }
                        },
                        {
                            path: 'invoiceoverallreport/:id?',
                            name: 'InvoiceOverallReport',
                            component: InvoiceOverallReport,
                            meta: {
                                requiresAuth: true,
                                title: 'فاکتور فروش'
                            }
                        },
                        {
                            path: 'billoverallreport/:id?',
                            name: 'BillOverallReport',
                            component: BillOverallReport,
                            meta: {
                                requiresAuth: true,
                                title: 'فاکتور خرید'
                            }
                        },                        
                        {
                            path: 'contacttransactions/:id?',
                            name: 'contacttransactions',
                            component: ContactTransactions,
                            meta: {
                                requiresAuth: true,
                                title: 'تراکنش های یک شخص'
                            }
                        },
                        {
                            path: 'accounttransactions/:id?',
                            name: 'accounttransactions',
                            component: AccountTransactions,
                            meta: {
                                requiresAuth: true,
                                title: 'تراکنش های یک حساب'
                            }
                        },
                        {
                            path: 'productoptionscardindex/:id?',
                            name: 'productoptionscardindex',
                            component: ProductOptionsCardindex,
                            meta: {
                                requiresAuth: true,
                                title: 'کاردکس زیرمحصول'
                            }
                        },
                        {
                            path: 'inventorydiscrepancy',
                            name: 'inventorydiscrepancy',
                            component: InventoryDiscrepancy,
                            meta: {
                                requiresAuth: true,
                                title: 'مغایرت گیری موجودی انبار'
                            }
                        },
                        {
                            path: 'lastprints',
                            name: 'lastprints',
                            component: LastPrints,
                            meta: {
                                requiresAuth: true,
                                title: 'آخرین پرینت ها'
                            }
                        },
                        {
                            path: 'extrareports',
                            name: 'extrareports',
                            component: ExtraReports,
                            meta: {
                                requiresAuth: true,
                                title: 'گزارشات دیگر'
                            }
                        },
                        {
                            path: 'deliverycontacts',
                            name: 'deliverycontacts',
                            component: DeliveryContacts,
                            meta: {
                                requiresAuth: true,
                                title: 'پیک'
                            }
                        },
                        {
                            path: 'referer',
                            name: 'referer',
                            component: Referer,
                            meta: {
                                requiresAuth: true,
                                title: 'گزارش فروش ها'
                            }
                        },
                        {
                            path: 'shopcardex',
                            name: 'shopcardex',
                            component: ShopCardex,
                            meta: {
                                requiresAuth: true,
                                title: 'گزارش فروش فروشگاه ها'
                            }
                        }
                        

                    ],
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'buy',
                    redirect: '/buy/inputs',
                    name: 'Buy',
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                        {
                            path: 'inputs/:id?',
                            name: 'Inputs',
                            component: Inputs,
                            meta: {
                                requiresAuth: true,
                                title: 'اقلام ورودی'
                            }
                        },
                        {
                            path: 'bills/:id?',
                            name: 'Bills',
                            component: Bills,
                            meta: {
                                requiresAuth: true,
                                title: 'فاکتورهای خرید'
                            }
                        }
                    ],
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'sell',
                    redirect: '/sell/outputs',
                    name: 'Sell',
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                        {
                            path: 'outputs/:id?',
                            name: 'Outputs',
                            component: Outputs,
                            meta: {
                                requiresAuth: true,
                                title: 'اقلام خروجی'
                            }
                        },
                        {
                            path: 'invoices/:id?',
                            name: 'Invoices',
                            component: Invoices,
                            meta: {
                                requiresAuth: true,
                                title: 'فاکتورهای فروش'
                            }
                        },
                        {
                            path: 'returnsdelivery/:id?',
                            name: 'returnsdelivery',
                            component: ReturnsDelivery,
                            meta: {
                                requiresAuth: true,
                                title: 'بازگشتی های پیک'
                            }
                        },
                        {
                            path: 'unaccountingsetinvoices',
                            name: 'unaccountingsetinvoices',
                            component: UnAccountingSetInvoices,
                            meta: {
                                requiresAuth: true,
                                title: 'فاکتورهای ثبت نشده'
                            }
                        }
                    ],
                    meta: {
                        requiresAuth: true
                    }
                },
            ],
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/pages',
            redirect: '/pages/404',
            name: 'Pages',
            component: {
                render(c) {
                    return c('router-view')
                }
            },
            children: [
                {
                    path: '404',
                    name: 'Page404',
                    component: Page404
                },
                {
                    path: '500',
                    name: 'Page500',
                    component: Page500
                },
                {
                    path: 'login',
                    name: 'Login',
                    component: Login
                },
                {
                    path: 'register',
                    name: 'Register',
                    component: Register
                }
            ]
        }
    ]
}

